import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './os-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class OsDetailComponent extends AbstractCollectionDirective {}
